exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nnav[data-v-dd97f58e] {\n  width: 100%;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  overflow: hidden;\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n  line-height: 24px;\n  font-family: \"Inter\", \"Rubik\", Arial, sans-serif;\n}\n@media only screen and (max-width: 599px) {\nnav[data-v-dd97f58e] {\n      position: relative;\n}\n}\nnav .block_right[data-v-dd97f58e] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    gap: 40px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dd97f58e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/navigation/Navbar.vue
// module id = 6fh0
// module chunks = 1